import storage from 'good-storage';

/* token */
const USER_TOKEN_KEY = '__usertoken__'
/* url */
const URL = '__url__'
/* 用户名 */
const USERNAME = '__userName__'
/* 管理员类型 */
const ADMINTYPE = '__adminType__'
/* 判读登录是一级管理员还是二级管理员 */
const ISADMIN = '__isAdmin__'
/* teamID */
const TEAMID = '__teamId__'
/* 登录头像 */
const LOGINIMG = '__loginImg__'
/* zzdId */
const ZZDID = '__zzdId__'
/* 部门选择哪一级 */
const ADMINISTER_LEVEL = '__administerLevel__'
/* 二级管理员权限 */
const TWO_LEVEL_AUTHRITY = '__twoLevelAuthrity__'

/* 存token */
function saveToken(val) {
  storage.set(USER_TOKEN_KEY, val)
}

/* 取token */
function getToken() {
  return storage.get(USER_TOKEN_KEY)
}


/* 删除token */
function deleteToken() {
  storage.remove(USER_TOKEN_KEY)
}

/* 存部门选择哪一级 */
function savedAministerLevel(val) {
  storage.set(ADMINISTER_LEVEL, val)
}

/* 取部门选择哪一级 */
function getAministerLevel() {
  return storage.get(ADMINISTER_LEVEL)
}

/* 删除部门选择哪一级 */
function deleteAministerLevel() {
  storage.remove(ADMINISTER_LEVEL)
}

/* 存判读登录是一级管理员还是二级管理员 */
function saveIsAdmin(val) {
  storage.set(ISADMIN, val)
}

/* 取判读登录是一级管理员还是二级管理员 */
function getIsAdmin() {
  return storage.get(ISADMIN)
}

/* 删除判读登录是一级管理员还是二级管理员 */
function deleteIsAdmin() {
  storage.remove(ISADMIN)
}

/* 存teamId */
function saveTeamId(val) {
  storage.set(TEAMID, val)
}
/* 取teamId */
function getTeamId() {
  return storage.get(TEAMID)
}
/* 删除teamId  */
function deleteTeamId() {
  storage.remove(TEAMID)
}

/* 存用户名 */
function saveUserName(val) {
  storage.set(USERNAME, val)
}

/* 取用户名 */
function getUserName() {
  return storage.get(USERNAME)
}

/* 删除用户名 */
function deleteUserName() {
  storage.remove(USERNAME)
}

/* 存管理员类型 */
function saveAdminType(val) {
  storage.session.set(ADMINTYPE, val)
}
/* 取管理员类型 */
function getAdminType() {
  return storage.session.get(ADMINTYPE)
}
/* 删除管理员类型 */
function deleteAdminType() {
  storage.session.remove(ADMINTYPE)
}

/* 存登录头像 */
function saveLoginImg(val) {
  storage.set(LOGINIMG, val)
}
/* 取登录头像 */
function getLoginImg() {
  return storage.get(LOGINIMG)
}
/* 删除登录头像 */
function deleteLoginImg() {
  storage.remove(LOGINIMG)
}

/* 存用户名 */
function saveZzd(val) {
  storage.set(ZZDID, val)
}

/* 取用户名 */
function getZzd() {
  return storage.get(ZZDID)
}

/* 存二级管理员权限 */
function saveTwolevelAuthrity(val) {
  storage.session.set(TWO_LEVEL_AUTHRITY, JSON.stringify(val))
}
function getTwolevelAuthrity() {
  if (storage.session.get(TWO_LEVEL_AUTHRITY) !== undefined) {
    return JSON.parse(storage.session.get(TWO_LEVEL_AUTHRITY))
  } else {
    return []
  }
}

export {
  getToken,
  saveToken,
  deleteToken,
  saveUserName,
  getUserName,
  deleteUserName,
  saveAdminType,
  getAdminType,
  deleteAdminType,
  saveIsAdmin,
  getIsAdmin,
  deleteIsAdmin,
  saveTeamId,
  getTeamId,
  deleteTeamId,
  saveLoginImg,
  getLoginImg,
  deleteLoginImg,
  saveZzd,
  getZzd,
  savedAministerLevel,
  getAministerLevel,
  deleteAministerLevel,
  saveTwolevelAuthrity,
  getTwolevelAuthrity
}
